import { render, staticRenderFns } from "./MatchingBonus.vue?vue&type=template&id=8037dee0&"
import script from "./MatchingBonus.vue?vue&type=script&lang=js&"
export * from "./MatchingBonus.vue?vue&type=script&lang=js&"
import style0 from "./MatchingBonus.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports